export const iconFontAwesomeEnergySun = (
	<i className="fa-solid fa-sun"></i>
);
